import { render } from "./CategoryStepBlock.vue?vue&type=template&id=e4f1bb3a"
import script from "./CategoryStepBlock.vue?vue&type=script&lang=js"
export * from "./CategoryStepBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__